import * as React from "react";

const StockStatus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <path
                fill="currentCOlor"
                d="M5.51484346,7.76484346 C5.36953104,7.91250014 5.13046825,7.91250014 4.98515582,7.76484346 L3.48515582,6.26484346 C3.3374995,6.11953139 3.3374995,5.88046861 3.48515582,5.73515618 C3.63046825,5.58749986 3.86953104,5.58749986 4.01484346,5.73515618 L5.24999964,6.97031236 L7.98515618,4.23515654 C8.13046825,4.08749986 8.36953104,4.08749986 8.51484311,4.23515654 C8.66249979,4.38046861 8.66249979,4.61953139 8.51484311,4.76484382 L5.51484346,7.76484346 Z M12,6 C12,9.31406236 9.31406236,12 6,12 C2.68593764,12 0,9.31406236 0,6 C0,2.68593764 2.68593764,0 6,0 C9.31406236,0 12,2.68593764 12,6 Z M6,0.75 C3.10078132,0.75 0.75,3.10078096 0.75,6 C0.75,8.89921904 3.10078132,11.25 6,11.25 C8.89921904,11.25 11.25,8.89921904 11.25,6 C11.25,3.10078096 8.89921904,0.75 6,0.75 Z"
            />
        </svg>
    );
};

export default React.memo(StockStatus);
